class NSSCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.overlayEl = document.querySelector(`nss-overlay`);
    this.overlayDetails = {
      element: `nss-cart-drawer`,
      zIndex: getComputedStyle(document.documentElement).getPropertyValue(`--nss-z-index-cart`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Cart Drawer] connected.`);

    this.initCartDrawer();

    document.addEventListener(`shopify:section:select`, (e) => {
      const targetChildEl = e.target.querySelector(`nss-cart-drawer`);
      if (targetChildEl === this) {
        if (this.debug) console.log(`[NSS][Cart Drawer] Editing cart drawer!`);
        this.openCart();
      } else {
        this.closeCart();
      }
    });

    window.NSS_OPEN_CART_DRAWER = () => {
      this.openCart();
    };

    window.NSS_CLOSE_CART_DRAWER = () => {
      this.closeCart();
    };

    this.addEventListener("overlayClosed", this.closeCart.bind(this));
  }

  toggleCart() {
    const status = document.documentElement.getAttribute(`nss-cart-drawer-open`);
    if (status === "true") {
      this.closeCart();
    } else {
      this.openCart();
    }
  }

  openCart() {
    const event = new CustomEvent("registerOverlay", {
      detail: this.overlayDetails,
    });
    this.overlayEl.dispatchEvent(event);
    document.documentElement.setAttribute(`nss-cart-drawer-open`, true);
    if (this.debug) console.log(`[NSS][Cart Drawer] Opened.`);
  }

  closeCart() {
    const event = new CustomEvent("unregisterOverlay", {
      detail: this.overlayDetails,
    });
    this.overlayEl.dispatchEvent(event);
    document.documentElement.setAttribute(`nss-cart-drawer-open`, false);
    if (this.debug) console.log(`[NSS][Cart Drawer] Closed.`);
  }

  initCartDrawer() {
    // Cart toggle events
    const cartToggleBtnEls = document.querySelectorAll(`[nss-open-cart-drawer]`);
    cartToggleBtnEls.forEach((cartToggleBtnEl) => {
      cartToggleBtnEl.addEventListener(`click`, (e) => {
        e.preventDefault();
        this.toggleCart();
      });
    });

    this.addEventListener(`click`, (e) => {
      if (e.target.hasAttribute(`nss-open-cart-drawer`)) {
        this.toggleCart();
      }
    });

    if (window.location.href.indexOf("#cart") > -1) {
      this.toggleCart();
    }
  }
}

let elementName = `nss-cart-drawer`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCartDrawer);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
